import { render, staticRenderFns } from "./Revise.vue?vue&type=template&id=6ee98d55&scoped=true&"
import script from "./Revise.vue?vue&type=script&lang=js&"
export * from "./Revise.vue?vue&type=script&lang=js&"
import style0 from "./Revise.vue?vue&type=style&index=0&id=6ee98d55&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee98d55",
  null
  
)

export default component.exports